import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { type UserOrderResponseWithFlags } from '@redteclab/api/clients/bully'
import { IconCaretRight } from '@redteclab/icons'

import { userSubOrderAccessorGetMultipleProductThumbnailAndName } from '../model/userSubOrderAccessor'
import { OrderSubOrderStatus } from '../orderStatus/OrderSubOrderStatus'

import { OrderDetailsProductImageList } from './OrderDetailsProductImageList'

export const OrderDetailsCard: FC<{
  href: string
  order: UserOrderResponseWithFlags
}> = ({ href, order }) => {
  const intl = useIntl()
  const productInfo =
    userSubOrderAccessorGetMultipleProductThumbnailAndName(order)

  if (!order.orderMasterData?.orderNumber) {
    return null
  }

  return (
    <a
      className="flex items-center justify-between rounded-2xl bg-light-primary-low p-4 shadow-m transition-all hover:bg-light-brand-medium hover:shadow-xl"
      href={href}
    >
      <div>
        <p className="text-start text-m font-medium">
          <FormattedMessage
            id="contact.ordersSection.card.title"
            values={{ date: intl.formatDate(order.orderMasterData.orderDate) }}
          />
        </p>
        {order.subOrders?.[0] ? (
          <div className="flex items-center gap-2">
            <OrderSubOrderStatus
              includeNowIndicator
              subOrder={order.subOrders[0]}
            />
          </div>
        ) : null}
        <OrderDetailsProductImageList products={productInfo} />
      </div>
      <IconCaretRight className="size-8 fill-dark-brand" />
    </a>
  )
}
